import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import useStyles from './styles';
import AddAssociationTable from './AddAssociationTable';
import GenericConfirmationModal from '../../../../../commons/GenericConfirmationModal';
import { viewedProductGroupCustom } from '../../../../../../utils/custom_prop_types/customPropTypes';

export default function SingleGroup({
  modals,
  setOpenModal,
  viewedProductGroup,
  deleteAssociation,
}) {
  const [rows, setRows] = useState(null);
  const [selectedAssociation, setSelectedAssociation] = useState({});
  const classes = useStyles();

  const handleDeleteButtonClick = (association) => {
    setOpenModal('deleteAssociationConfirmation', true);
    setSelectedAssociation(association);
  };

  useEffect(() => {
    setRows(viewedProductGroup);
  }, [viewedProductGroup]);

  return (
    <Box>
      <AddAssociationTable />
      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table aria-label="Product info" className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>Multiplier</TableCell>
              <TableCell>Associated number</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className={classes.tableBody}>
            {rows?.['hydra:member']?.map((row) => (
              <TableRow key={row['@id']}>
                <TableCell>{row.multiplier}</TableCell>
                <TableCell>
                  {row.associatedProductGroup.number}
                </TableCell>
                <TableCell>{row.associatedProductGroup.products[0]?.description}</TableCell>
                <TableCell>
                  <Button
                    className={classes.button}
                    variant="contained"
                    color="secondary"
                    startIcon={<DeleteIcon />}
                    onClick={() => handleDeleteButtonClick(row)}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {modals.deleteAssociationConfirmation
      && (
        <GenericConfirmationModal
          confirmationType="deleteAssociationConfirmation"
          confirmedFunction={() => deleteAssociation(selectedAssociation['@id'])}
          informationalHeader={`You are going to delete an association between
          ${viewedProductGroup.number} and ${selectedAssociation.associatedProductGroup.number}`}
        />
      )}
    </Box>
  );
}

SingleGroup.propTypes = {
  modals: PropTypes.objectOf(PropTypes.bool).isRequired,
  setOpenModal: PropTypes.func.isRequired,
  viewedProductGroup: viewedProductGroupCustom.isRequired,
  deleteAssociation: PropTypes.func.isRequired,
};
